import bizcatelog from './smile_bizcatelog';
import configuration from './smile_configuration'

export default {
  namespaced: true,
  modules: {
    bizcatelog: bizcatelog,
    configuration: configuration
  }
};



// WEBPACK FOOTER //
// ./src/store/smile/smile.js